import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseSiteService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-reset-password-confirmation',
  templateUrl: './reset-password-confirmation.component.html',
  styleUrls: ['./reset-password-confirmation.component.scss'],
})
export class ResetPasswordConfirmationComponent implements OnInit, OnDestroy {
  userAgentData: any = {};
  baseSiteId: string;
  baseSiteSub: Subscription;
  constructor(private readonly baseSite: BaseSiteService) {}

  ngOnInit(): void {
    this.baseSiteSub = this.baseSite
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));

    this.userAgentData = JSON.parse(localStorage.getItem('userDetails'));
    localStorage.removeItem('userDetails');
  }
  ngOnDestroy(): void {
    this?.baseSiteSub?.unsubscribe();
  }
}
